<template>
  <div class="blog-types-container">
    <h2>Blog Types</h2>
    <div class="blog-types-empty" v-if="blogTypes.length === 0">
      No blogtypes found.
    </div>
    <ul class="blog-types-list" v-else>
      <li
        class="blog-types-item"
        v-for="blogType in blogTypes"
        :key="blogType.id"
      >
        <div class="blog-types-item-details">
          <h3>{{ blogType.name }}</h3>
          <p>{{ blogType.slug }}</p>
        </div>
        <div class="blog-types-item-actions">
          <button @click="editBlogType(blogType)">Edit</button>
          <button @click="deleteBlogType(blogType)">Delete</button>
        </div>
      </li>
    </ul>
    <form class="blog-types-form" v-if="showForm" @submit.prevent="submitForm">
      <h3>New Blog Type</h3>
      <div class="blog-types-form-group">
        <label for="name">Name:</label>
        <input type="text" id="name" v-model="formData.name" />
      </div>
      <div class="blog-types-form-group">
        <label for="slug">Slug:</label>
        <input type="text" id="slug" v-model="formData.slug" />
      </div>
      <button class="blog-types-form-submit">Save</button>
    </form>
    <button class="blog-types-add-btn" @click="showForm = true">
      New Blog Type
    </button>
  </div>
</template>

<script>
import { axios } from '../../../utils'
export default {
  data() {
    return {
      blogTypes: [],
      showForm: false,
      formData: {
        name: '',
        slug: ''
      },
      editingBlogType: null
    }
  },
  created() {
    this.fetchBlogTypes()
  },
  methods: {
    fetchBlogTypes() {
      axios
        .get('/api/admin/blog-types')
        .then(response => {
          this.blogTypes = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    editBlogType(blogType) {
      this.editingBlogType = blogType
      this.formData.name = blogType.name
      this.formData.slug = blogType.slug
      this.showForm = true
    },
    deleteBlogType(blogType) {
      axios
        .delete(`/api/admin/blog-types/${blogType.slug}`)
        .then(() => {
          this.fetchBlogTypes()
        })
        .catch(error => {
          console.log(error)
        })
    },
    submitForm() {
      if (this.editingBlogType) {
        this.updateBlogType()
      } else {
        this.createBlogType()
      }
    },
    createBlogType() {
      console.log(this.formData)
      axios
        .post('/api/admin/blog-types/create', this.formData)
        .then(() => {
          this.fetchBlogTypes()
          this.resetForm()
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateBlogType() {
      axios
        .put(
          `/api/admin/blog-types/${this.editingBlogType.slug}`,
          this.formData
        )
        .then(() => {
          this.fetchBlogTypes()
          this.resetForm()
        })
        .catch(error => {
          console.log(error)
        })
    },
    resetForm() {
      this.showForm = false
      this.editingBlogType = null
      this.formData.name = ''
      this.formData.slug = ''
    }
  }
}
</script>

<style scoped>
.blog-types-container {
  margin: 20px auto;
  max-width: 800px;
}

.blog-types-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.blog-types-header h2 {
  font-size: 24px;
}

.blog-types-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.blog-types-list li {
  margin-bottom: 20px;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  transition: all 0.3s ease;
}

.blog-types-list li:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.blog-types-list li h3 {
  margin-top: 0;
  font-size: 20px;
}

.blog-types-list li p {
  margin-bottom: 10px;
  font-size: 16px;
  color: #666;
}

.blog-types-list li button {
  margin-right: 10px;
  padding: 8px 16px;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.blog-types-list li button:hover {
  background-color: #0069d9;
}

.blog-types-form {
  margin-top: 20px;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

.blog-types-form label {
  display: block;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
}

.blog-types-form input {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  margin-bottom: 20px;
}

.blog-types-form button {
  padding: 8px 16px;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.blog-types-form button:hover {
  background-color: #0069d9;
}

.error-message {
  color: red;
  font-size: 14px;
}
</style>
